<wo-order-state
  [state]="active ? ActivityState.Active : ActivityState.Inactive"
  [small]="small"
/>
